/**
 * @flow
 */

import React, { Component } from 'react'
import MediaQuery from 'react-responsive'
import { ThemeProvider } from 'emotion-theming'

import defaulttheme from '../../../../../constants/themeConstants'
import EnquireNowButton from '../../../common/EnquireNowButton'
import styles from './styles.module.scss'

import {
  ImageAndContentContainer,
  EnquireNowButtonContainer,
  FutureTextItem,
  FutureItemHead,
  FutureItemTitle,
  FutureImageItem,
  FutureSection,
  SectionImage,
  FutureItemImg,
  FutureItemDescription
} from './styledComponents'

const ContentSection = props => {
  const {
    futureItemTitle,
    futureItemDescription,
    galleryPresent,
    webpsrc,
    mainImage,
    mobileImage,
    // formData,
    // glsLoaded,
    id
  } = props
  return (
    <FutureTextItem>
      <FutureItemTitle
        as="h3"
        dangerouslySetInnerHTML={{
          __html: futureItemTitle
        }}
      />
      <FutureItemDescription>{futureItemDescription}</FutureItemDescription>
      <MediaQuery query="(max-device-width: 767px)">
        {galleryPresent ? (
          <FutureImageItem />
        ) : (
          <div>
            <FutureItemHead>
              <MediaQuery query="(min-device-width: 768px)">
                <FutureItemImg
                  dataSrc={webpsrc || mainImage}
                  alt={futureItemTitle}
                  className="lazyload"
                />
              </MediaQuery>
              <MediaQuery query="(max-device-width: 767px)">
                <FutureItemImg
                  dataSrc={webpsrc || mobileImage}
                  alt={futureItemTitle}
                  className="lazyload"
                />
              </MediaQuery>
            </FutureItemHead>
          </div>
        )}
      </MediaQuery>
      <EnquireNowButtonContainer>
        <EnquireNowButton id={`${id}-enquire-button`} />
      </EnquireNowButtonContainer>
    </FutureTextItem>
  )
}

const ImageSection = props => (
  <MediaQuery query="(min-device-width: 768px)">
    <div>
      <FutureItemHead>
        <MediaQuery query="(min-device-width: 768px)">
          <SectionImage
            dataSrc={props.webpsrc || props.mainImage}
            alt={props.futureItemTitle}
            className="lazyload"
          />
        </MediaQuery>
        <MediaQuery query="(max-device-width: 767px)">
          <SectionImage
            dataSrc={props.webpsrc || props.mobileImage}
            alt={props.futureItemTitle}
            className="lazyload"
          />
        </MediaQuery>
      </FutureItemHead>
    </div>
  </MediaQuery>
)

const LeftImageComponent = props => (
  <ImageAndContentContainer>
    <div className={styles.vcenter} style={{ width: `${props.imageWidth}%` }}>
      <ImageSection {...props} />
    </div>
    <div
      className={`${styles.vcenter} ${styles.paddingLeft}`}
      style={{ width: `${props.contentWidth}%` }}
    >
      <ContentSection {...props} />
    </div>
  </ImageAndContentContainer>
)

LeftImageComponent.defaultProps = {
  imageWidth: 40,
  contentWidth: 60
}

const RightImageComponent = props => (
  <ImageAndContentContainer>
    <div
      className={`${styles.vcenter} ${styles.paddingRight}`}
      style={{ width: `${props.contentWidth}%` }}
    >
      <ContentSection {...props} />
    </div>
    <div className={styles.vcenter} style={{ width: `${props.imageWidth}%` }}>
      <ImageSection {...props} />
    </div>
  </ImageAndContentContainer>
)
RightImageComponent.defaultProps = {
  imageWidth: 40,
  contentWidth: 60
}
class Section extends Component {
  componentDidMount() {}
  render() {
    const { id } = this.props
    return (
      <ThemeProvider theme={defaulttheme}>
        <FutureSection id={id}>
          {this.props.imagePosition === 'LEFT' ? (
            <LeftImageComponent {...this.props} />
          ) : (
            <RightImageComponent {...this.props} />
          )}
        </FutureSection>
      </ThemeProvider>
    )
  }
}
export default Section



// WEBPACK FOOTER //
// ./src/components/Events/EventsDescriptionSection/components/Section/index.js